import {
  StatisticsOverviewTableStore,
  STATISTICS_OVERVIEW_TABLE_STORE,
  StatsOverviewTableEntity, STATISTICS_OVERVIEW_STORE, StatisticsOverviewStore
} from 'store'
import { StyleProps } from 'utilities'

export type OverviewProjectsTableBodyLineProps = StyleProps & {
  tableEntity: StatsOverviewTableEntity
  mainEntitySubLevel?: number
  [STATISTICS_OVERVIEW_TABLE_STORE]?: StatisticsOverviewTableStore
  [STATISTICS_OVERVIEW_STORE]?: StatisticsOverviewStore
}

export enum SelectedEntityGraphColor {
  FIRST = '#254291',
  SECOND = '#3AABF2',
  THIRD = '#70D6C6',
  FORTH = '#70D6C6',
  FIFTH = '#70D6C6',
  SIXTH = '#70D6C6'
}
